import * as Bowser from "bowser";

export const isSafari = () => {
  const browser = Bowser.getParser(window.navigator.userAgent);
  const browserName = browser.getBrowser().name;

  return browserName === "Safari";
};

export const base64toBlob = (base64) =>
  fetch(`${base64}`).then((res) => res.blob());

export const getBase64 = (file): Promise<string | ArrayBuffer> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result!);
    reader.onerror = (error) => reject(error);
  });
};
